import { AssetListByTypeQuery } from 'gql/graphql';

export type Device =
  AssetListByTypeQuery['assetListByType']['devices'][number] & {
    type: 'device';
  };

export type Property =
  AssetListByTypeQuery['assetListByType']['properties'][number] & {
    type: 'property';
  };
export type Asset = Device | Property;
export const assetGroups = [
  { label: 'Devices', key: 'devices' },
  { label: 'Properties', key: 'properties' },
] as const;
